import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const DOCUMENTS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('DOCUMENTS');
export const DOCUMENTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	DOCUMENTS_CRUD_ACTION_CONSTANTS
);
